import React, {useState, forwardRef, useImperativeHandle, useRef, useContext} from 'react';
import {notification, Row, Col, Modal} from 'antd';
import ConfigPage from '@/page/customer/WelcomPage/config';
import View from '@/page/customer/WelcomPage/config/View';
import SendArea from '@/page/customer/WelcomPage/config/SendArea';
import MsgContext from '@/page/customer/WelcomPage/msgContext';

const WelcomeModal = forwardRef(({reload}, ref) => {
    const [visible, setVisible] = useState(false);
    const [type, setType] = useState(1);
    const [title, setTitle] = useState('新增欢迎语');
    const [configId, setConfigId] = useState(null);
    const configRef = useRef();
    const {selectedUsers} = useContext(MsgContext);
    useImperativeHandle(ref, () => ({
        open,
    }));

    function close() {
        setVisible(false);
    }

    function open(type, configId = null) {
        setType(type);
        setConfigId(configId);
        let title;
        if (type === 1) {
            title = '新增欢迎语';
        } else if (type === 3) {
            title = '查看欢迎语';
        } else {
            title = '编辑欢迎语';
        }
        setTitle(title);
        setVisible(true);
    }

    function save() {
        if (type !== 3) {
            configRef.current.saveOrUpdate(configId);
        }
        if (type === 1) {
            if (selectedUsers.length === 0) {
                notification.warn({
                    message: '请选择生效员工',
                });
            } else {
                setVisible(false);
            }
        } else {
            setVisible(false);
        }
    }

    return (
        <Modal
            title={title}
            destroyOnClose
            width={type === 3 ? '40%' : '90%'}
            visible={visible}
            onCancel={close}
            onOk={save}
        >
            <Row>
                {type !== 3 && (
                    <Col span={16}>
                        {type !== 2 && <SendArea />}
                        <ConfigPage ref={configRef} reload={reload} isEdit={type == 2} />
                    </Col>
                )}
                <Col span={8} offset={type === 3 ? 4 : 0}>
                    <View />
                </Col>
            </Row>
        </Modal>
    );
});

WelcomeModal.displayName = 'WelcomeModal';

export default WelcomeModal;
